<div class="input-combo-container">
  <p class="input-combo-title">Showing catalogue for</p>
  <div class="input-combo-sub-container">
    <ng-select [items]="comboList"
      bindLabel="SelectionDisplay"
      bindValue="SelectionValue"
      [ngClass]="{'input-combo': true}"
      (open)="getList()"
      (change)="onValueChange($event)"
      [searchable]="true"
      [clearable]="false"
      placeholder="Please select"
      [(ngModel)]="selectedCombo">
    </ng-select>
  </div>
</div>